export default "__VITE_ASSET__6e0a940d__"